export const NOTIFICATION_OVERLAY = 'notification-overlay';
